// extracted by mini-css-extract-plugin
module.exports = {"heroImageSegment":"HeroImageSegment-HeroImageSegment-module--hero-image-segment--c9moa"};